// extracted by mini-css-extract-plugin
var _1 = "EpostStatusTimelineContent-modulecontentWrapper__Y7T1U Content-modulecontentWrapper__p1AMw";
var _2 = "EpostStatusTimelineContent-moduledivider__IaDXi Divider-moduleDivider__dL3Vg";
export { _1 as "contentWrapper", _2 as "divider" }
